import { COSTCOGROCERY_FACET_KEY } from '../SearchResultsFacets/constants';

import { getKeyValue } from '@/services/content/data';
import { Box } from '@mui/material';
import {
    ColorBlue40,
    ColorRed40,
    FontSize300,
    FontWeightBold,
} from '@nxt-costco-com/forge-design-tokens';
import type {
    ContentStackEntryDataProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

export function CostcoGroceryLabel({
    locale,
    facetConfig,
}: {
    locale: LocaleProps;
    facetConfig: ContentStackEntryDataProps;
}) {
    const [labelPartOne, labelPartTwo] = (
        getKeyValue(COSTCOGROCERY_FACET_KEY, facetConfig) ?? ''
    ).split(' ');

    if (!labelPartOne || !labelPartTwo) {
        return null;
    }

    return (
        <>
            <Box
                component="span"
                // FR translation begins with french word for grocery,
                // so we swap colors to ensure Costco is red & Grocery is blue
                sx={{
                    color: locale === 'fr-ca' ? ColorBlue40 : ColorRed40,
                    fontWeight: FontWeightBold,
                    fontSize: FontSize300,
                }}
            >
                {labelPartOne}
            </Box>
            <Box
                component="span"
                sx={{
                    color: locale === 'fr-ca' ? ColorRed40 : ColorBlue40,
                    fontWeight: FontWeightBold,
                    fontSize: FontSize300,
                }}
            >
                {labelPartTwo}
            </Box>
        </>
    );
}
